<BI-grid-layout [cols]="['100%']" [gap]="3">

      <BI-grid-layout-item [row]="1" [col]="1">
        <BI-Nav [navButtons]="navButtons" [PageTitle]="GetPageTitle()">
          <button class='mx-1 outline' (click)="onCancel()">{{'Cancel'| translate }}</button>
          <button class='mx-1 primary-btn' (click)="ChangePassword()">{{'Save'| translate }}</button>
      </BI-Nav>
      </BI-grid-layout-item>


    <BI-grid-layout-item class='main' [row]="2" [col]="1">

        <BI-grid-layout-item [row]="1" [col]="1">
          <bi-control-list-2col #ref [formGroup]='formGroup' [controlList]='controlList' />
        </BI-grid-layout-item>

    </BI-grid-layout-item>

</BI-grid-layout>
